var _style, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Danger-st0{fill:currentColor;}\r\n\t.Danger-st1{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.Danger-st2{fill:currentColor;stroke:#FFFFFF;stroke-width:5.000000e-02;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Danger-st0",
    d: "M3.5,7.1C1.6,7.1,0,5.5,0,3.5S1.6,0,3.5,0S7,1.6,7,3.5S5.5,7.1,3.5,7.1z M3.5,0.9C2,0.9,0.8,2.1,0.8,3.6 S2,6.3,3.5,6.3C5,6.2,6.2,5,6.2,3.5C6.2,2.1,5,0.9,3.5,0.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Danger-st0",
    d: "M20.5,7.1c-2,0-3.5-1.6-3.5-3.5S18.5,0,20.5,0S24,1.6,24,3.5S22.4,7.1,20.5,7.1z M20.5,0.9 c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7C23.1,2.1,21.9,0.9,20.5,0.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Danger-st0",
    d: "M3.5,24c-2,0-3.5-1.6-3.5-3.5S1.6,17,3.5,17S7,18.6,7,20.5S5.5,24,3.5,24z M3.5,17.8c-1.5,0-2.7,1.2-2.7,2.7 s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7S5,17.8,3.5,17.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Danger-st0",
    d: "M20.5,24c-2,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S22.4,24,20.5,24z M20.5,17.8 c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7C23.1,19,21.9,17.8,20.5,17.8z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "Danger-st1",
    x1: 6.8,
    y1: 3.5,
    x2: 17.2,
    y2: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "Danger-st1",
    x1: 6.8,
    y1: 20.5,
    x2: 17.2,
    y2: 20.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "Danger-st1",
    x1: 20.5,
    y1: 6.8,
    x2: 20.4,
    y2: 17.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "Danger-st1",
    x1: 3.5,
    y1: 6.5,
    x2: 3.5,
    y2: 17.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Danger-st2",
    d: "M17.7,16c-1.7-2.9-3.4-5.8-5.2-8.6c-0.4-0.6-0.8-0.6-1.2,0c-1.6,2.9-3.3,5.7-5,8.6c-0.1,0.2-0.2,0.5-0.1,0.8 c0.2,0.3,0.4,0.3,0.7,0.3c1.7,0,3.4,0,5.1,0s3.4,0,5.1,0c0.3,0,0.5,0,0.7-0.3C18,16.5,17.9,16.3,17.7,16z M12,14.6 c0.4,0,0.7,0.3,0.7,0.7s-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7S11.6,14.6,12,14.6z M11.4,9.5h1.2l-0.1,4.1h-0.9L11.4,9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.9ffe8e334005a6481668872dab5fbdfe.svg";
export { ForwardRef as ReactComponent };